import { ArrowLeft } from "lucide-react";
import { Link } from "@tanstack/react-router";

function LegalHeader() {
  return (
    <div className="px-3 pt-3 sm:px-5 sm:pt-5">
      <div className="mx-auto flex max-w-5xl items-center justify-between rounded-2xl border border-white/10 bg-[#171717] px-4 py-3 shadow-2xl shadow-black/10 sm:px-5">
        <Link to="/" className="flex items-center gap-2.5" aria-label="Innovally, início">
          <img
            src="/logo-icon.png"
            alt=""
            className="h-8 w-8 object-contain"
            width={220}
            height={220}
            loading="eager"
          />
          <span className="font-display text-sm font-bold tracking-[-0.03em] text-white sm:text-base">
            Innovally
          </span>
        </Link>

        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-xs font-medium text-white/70 transition-colors hover:text-white"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Voltar ao início
        </Link>
      </div>
    </div>
  );
}

export { LegalHeader };
